export enum DvirInspectionQuestionDataType {
  TEXT = 'TEXT',
  DROPDOWN = 'DROPDOWN',
}
